import { useId } from 'react';

/**
 * SendAnimatedIcon — Ícone de enviar (paper plane) animado padrão do Joshua.
 *
 * Uso: envolva com um elemento que tenha a classe `send-animated`
 * para ativar a animação no hover (plane launch + trail draw-in).
 *
 * Exemplo:
 *   <button className="btn-add send-animated" onClick={onSend}>
 *     <SendAnimatedIcon size={15} />
 *     <span className="btn-text">Enviar</span>
 *   </button>
 */
export default function SendAnimatedIcon({ size = 15 }) {
  const id = useId();
  const gid = `sendG${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <defs>
        <linearGradient id={gid} gradientUnits="userSpaceOnUse" x1="2" y1="12" x2="22" y2="2">
          <stop offset="0%" stopColor="#60a5fa" />
          <stop offset="100%" stopColor="#154680" />
        </linearGradient>
      </defs>
      <g className="send-plane" stroke={`url(#${gid})`}>
        <path d="m22 2-7 20-4-9-9-4Z"/>
      </g>
      <g className="send-trail" stroke={`url(#${gid})`}>
        <path d="m22 2-11 11"/>
      </g>
    </svg>
  );
}
